webpackJsonp([5],{

/***/ 180:
/***/ (function(module, exports) {

module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.e2fce98eef0065fe3d9b.js